<template>
  <div class="Accordion" :class="{ 'expand': showBody }" :id="accordionId">
    <div class="Accordion_header flex-between" @click="toggle()" @mouseleave="mouseleave(closePopUp)" @mouseover="mouseover(closePopUp)">
      <h3 class="Accordion_title" :class="{'Accordion_disabled': closePopUp}">
        <slot name="title"></slot>
      </h3>
      <v-popover
        v-if="closePopUp"
        offset="5"
        trigger="manual"
        placement="bottom-end"
        :open="isOpen"
        class="accordion-pop"
      >
        <template slot="popover">
          <div>{{ $t('subscription_details.accordion.shippingConfirmed.popUp.message', 'This feature is currently unavailable, as we are still processing your order') }}</div>
        </template>
      </v-popover>
      <slot name="right-icon">
        <span class="Accordion_arrow" :class="{'Accordion_arrow_hide': closePopUp}">
          <app-icon name="chevron-thin-down" />
        </span>
      </slot>
    </div>
    <div class="Accordion_body">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'accordion',

    props: {
      title: {
        type: String,
        default: null
      },

      index: {
        type: Number,
        default: 1
      },

      id: {
        type: String,
        default: null
      },

      closePopUp: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        showBody: false,
        isOpen: false
      }
    },

    computed: {
      accordionId () {
        return this.id ? this.id : 'accordion_' + this.index
      }
    },

    mounted () {
      this.$bus.$on('expend-modify-accordion', () => {
        if (this.id === 'buy_your_subscription' || this.id === 'modify_your_subscription') {
          this.showBody = true
        }

        if (this.id === 'new_flow_to_cancel_subscription' || this.id === 'cancel_your_subscription') {
          this.showBody = false
        }
      })
    },

    methods: {
      toggle (accordionId) {
        if (!this.closePopUp) {
          if (this.title) {
            this.trackConversion({ name: 'interaction', description: this.title })
          }
          if (accordionId) {
            this.$parent.$emit('toggle-accordion', accordionId)
          } else {
            this.$parent.$emit('toggle-accordion', this.accordionId)
          }
          this.$emit('toggle', { expand: this.showBody })
        }
      },

      mouseleave (closePopUp) {
        if (closePopUp) {
          this.isOpen = false
        }
      },

      mouseover (closePopUp) {
        if (closePopUp) {
          this.isOpen = true
        }
      },

      closeTooltip (closePopUp) {
        if (closePopUp) {
          this.isOpen = false
        }
      }
    }
  }
</script>

<style lang="scss">
  .Accordion {
    margin-bottom: .08rem;

    &:last-child {
      margin-bottom: 0;
    }

    @include media(tablet) {
      margin-bottom: .14rem;
    }

    &.expand {
      margin-bottom: 0;

      > .Accordion_body {
        display: block;
      }

      > .Accordion_header {
        .Accordion_arrow {
          transform: rotate(-180deg);
        }
      }
    }

    &_header {
      background: rgba(0, 102, 161, .15);
      padding: .255rem .15rem;
      color: $blue;
      font-weight: 500;
      cursor: pointer;
      position: relative;
    }

    &_arrow {
      display: inline-flex;

      .icon-chevron-thin-down {
        color: #fff;
      }

      @include media(tablet) {
        margin: 0 .12rem;
      }
    }

    &_disabled {
      color: #c4c4c4;
      font-size: .14rem;
      letter-spacing: -.0002rem;
      line-height: .19rem;
    }

    &_arrow_hide {
      display: none;
    }

    &_title {
      font-weight: 500;
      font-size: .14rem;
    }

    &_body {
      display: none;
      padding: .15rem 0;

      @include media(tablet) {
        padding: .25rem .15rem;
      }
    }

    &-sub {
      @include media(tablet) {
        margin-bottom: .1rem;
      }

      .Accordion_header {
        background: #f5f5f5;
        padding: .12rem .14rem;
        color: #212121;
      }

      .Accordion_arrow {
        margin: 0 .08rem;

        .icon {
          width: .12rem;
          height: .12rem;
          color: #787878 !important;
        }
      }
    }
  }

  .accordion-pop {
    display: flex;
    position: absolute;
    right: 50%;
    top: 70%;
    transform: translateY(-50%);
    cursor: pointer;
  }
</style>
